// extracted by mini-css-extract-plugin
module.exports = {"textPrompt":"GiftCardTextPrompt_textPrompt__tnrGA"};